import React from 'react'
import {Link} from 'react-router-dom'
import {Button, Container, MainHeading} from '../../globalStyles'
import {HeroVideo, HeroSection, HeroText, ButtonWrapper} from './HeroStyles'




const Hero = () => {
  return(
    <HeroSection>
        <HeroVideo src='./assets/heroVideo.mp4' muted autoPlay loop/>
        <Container>
            <MainHeading>Strings and more</MainHeading>

            <HeroText>Das Rockorchester aus Hirrlingen</HeroText>
            <ButtonWrapper>
                <Link to="kontakt">
                    <Button>Kontakt</Button>
                </Link>
            </ButtonWrapper>
        </Container>

    </HeroSection>
  )
}

export default Hero